import { render, staticRenderFns } from "./product-details-marketing.vue?vue&type=template&id=088fd098&scoped=true&"
import script from "./product-details-marketing.vue?vue&type=script&lang=js&"
export * from "./product-details-marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088fd098",
  null
  
)

export default component.exports